import t from "./highrise1304.mjs";
function e() {
  this.__data__ = new t(), this.size = 0;
}
export {
  e as default
};
